/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTcuNDUgNi43MjI1OEM4LjY1IDcuNTIyNTggOS44MyA3Ljc4MjU4IDEwLjg5IDcuNzgyNThDMTIuOTMgNy43ODI1OCAxNC40NyA2Ljc4MjU4IDE0LjU2IDYuNzIyNThMMTMuNDUgNS4wNjI1OEMxMy40NSA1LjA2MjU4IDEwLjk4IDYuNjcyNTggOC41NiA1LjA2MjU4QzUuMDUgMi43MjI1OCAxLjYgNC45NjI1OCAxLjQ1IDUuMDYyNThMMi41NiA2LjcyMjU4QzIuNTYgNi43MjI1OCA1LjAzIDUuMTEyNTggNy40NSA2LjcyMjU4WiIgZmlsbD0iaW5oZXJpdCIvPjxwYXRoIGQ9Ik0xNCA5LjVIMlYxMS41SDE0VjkuNVoiIGZpbGw9ImluaGVyaXQiLz4=";